import { Search } from "@mui/icons-material";
import {
  Box,
  Button,
  Chip,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { GridFilterListIcon } from "@mui/x-data-grid";
import { DatePicker } from "@mui/x-date-pickers";
import { useState } from "react";
import { PRIORITIES, QUOTE_STATUSES } from "../../../constants/QuotesConstants";

export const QuoteFilters = ({
  filters,
  onFiltersChange,
  onClearFilters,
  loading,
}) => {
  const [showFilters, setShowFilters] = useState(true);

  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2,
        }}
      >
        <Typography variant="h6">Filtros de Búsqueda</Typography>
        <Button
          variant="outlined"
          onClick={() => setShowFilters(!showFilters)}
          startIcon={<GridFilterListIcon />}
        >
          {showFilters ? "Ocultar" : "Mostrar"} Filtros
        </Button>
      </Box>

      {/* Búsqueda principal siempre visible */}
      <TextField
        fullWidth
        placeholder="Buscar por cliente, email, producto o ID de cotización..."
        value={filters.search}
        onChange={(e) => onFiltersChange({ search: e.target.value })}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
        sx={{ mb: showFilters ? 2 : 0 }}
      />

      {/* Filtros expandibles */}
      {showFilters && (
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <FormControl fullWidth>
              <InputLabel>Estado</InputLabel>
              <Select
                value={filters.status}
                onChange={(e) => onFiltersChange({ status: e.target.value })}
                MenuProps={{ disableScrollLock: true }}
                label="Estado"
              >
                <MenuItem value="">Todos los estados</MenuItem>
                {Object.entries(QUOTE_STATUSES).map(([key, config]) => (
                  <MenuItem key={key} value={key}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {config.icon}
                      <Box sx={{ ml: 1 }}>{config.label}</Box>
                    </Box>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <FormControl fullWidth>
              <InputLabel>Prioridad</InputLabel>
              <Select
                value={filters.priority}
                onChange={(e) => onFiltersChange({ priority: e.target.value })}
                MenuProps={{ disableScrollLock: true }}
                label="Prioridad"
              >
                <MenuItem value="">Todas las prioridades</MenuItem>
                {Object.entries(PRIORITIES).map(([key, config]) => (
                  <MenuItem key={key} value={key}>
                    <Chip
                      label={config.label}
                      color={config.color}
                      size="small"
                    />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <DatePicker
              label="Fecha desde"
              value={filters.date_from}
              onChange={(date) => onFiltersChange({ date_from: date })}
              slotProps={{
                textField: { fullWidth: true },
              }}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <DatePicker
              label="Fecha hasta"
              value={filters.date_to}
              onChange={(date) => onFiltersChange({ date_to: date })}
              slotProps={{
                textField: { fullWidth: true },
              }}
            />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
              <Button onClick={onClearFilters} variant="outlined">
                Limpiar Filtros
              </Button>
            </Box>
          </Grid>
        </Grid>
      )}
    </Paper>
  );
};
